module.exports = "/_next/static/images/3-150e3166ec169b708ba482b6f251aeba.jpg";